
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.192 8H.808C.362 8 0 7.552 0 7s.362-1 .808-1h18.384c.446 0 .808.448.808 1s-.362 1-.808 1m0-6H.808C.362 2 0 1.552 0 1s.362-1 .808-1h18.384c.446 0 .808.448.808 1s-.362 1-.808 1M.808 14C.362 14 0 13.552 0 13s.362-1 .808-1h18.384c.446 0 .808.448.808 1s-.362 1-.808 1H.808z","fill":"#00325B","fill-rule":"evenodd"}})])
          )
        }
      }
    